import React from 'react';
import { batteryToText } from 'utils/utils';
import statusConverter from 'utils/statusConverter';

export const columnSetter = (moduleScn) => {
  const columns = [
    {
      Header: 'No',
      accessor: 'rnum',
    },
    {
      Header: '설비번호',
      accessor: 'areaNo',
    },
    {
      Header: '설비명',
      accessor: 'areaNm',
    },
    {
      Header: '감지기No.',
      accessor: 'modelNm',
    },
    {
      Header: (
        <span>
          O<sub>2</sub>(%)
        </span>
      ),
      accessor: 'o2',
    },
    {
      Header: (
        <span>
          H<sub>2</sub>S(ppm)
        </span>
      ),
      accessor: 'h2s',
    },
    {
      Header: <span>CO(ppm)</span>,
      accessor: 'co',
    },
    {
      Header: (
        <span>
          CH<sub>4</sub>(%LEL)
        </span>
      ),
      accessor: 'hc',
    },
    {
      Header: (
        <span>
          CO<sub>2</sub>(%)
        </span>
      ),
      accessor: 'co2',
    },
    {
      id: 'status',
      Header: () => <div>상태</div>,
      Cell: ({ row }) => statusConverter(row.original.status, row.original.statusCode),
    },
    {
      id: 'Battery',
      Header: () => <div>Battery(%)</div>,
      Cell: ({ row }) => batteryToText(row.original.battery),
    },
    {
      Header: '측정시간',
      accessor: 'regDate',
    },
  ];

  return columns;
};
